export default "__VITE_ASSET__7sT2EtzT__"